import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';

import {AuthenticationService} from '../_services';

@Injectable()
export class LocaleInterceptor implements HttpInterceptor {

  constructor(
    private authenticationService: AuthenticationService,
    @Inject(LOCALE_ID) protected localeId: string) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Agrega cabecera con localeID
    request = request.clone({
      setHeaders: {
        'Accept-Language': this.localeId
      }
    });

    return next.handle(request);
  }
}
